import { render, staticRenderFns } from "./OpeningHoursChange.vue?vue&type=template&id=79ea70c5&scoped=true&"
import script from "./OpeningHoursChange.vue?vue&type=script&lang=js&"
export * from "./OpeningHoursChange.vue?vue&type=script&lang=js&"
import style0 from "./OpeningHoursChange.vue?vue&type=style&index=0&id=79ea70c5&lang=scss&scoped=true&"
import style1 from "./OpeningHoursChange.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ea70c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
